"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const MagnifyingGlassIcon = ({
  color,
  title,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", { ...otherProps,
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "23",
  fill: "none",
  viewBox: "0 0 22 23",
  children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    children: title
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M21.03 22.49a.966.966 0 01-.684-.284l-5.395-5.395a.968.968 0 111.37-1.37l5.395 5.395a.968.968 0 01-.685 1.654z",
    clipRule: "evenodd"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M9.166 2.33c-4.039 0-7.325 3.288-7.327 7.33.002 4.038 3.287 7.324 7.325 7.324 4.042 0 7.33-3.286 7.33-7.326-.001-4.041-3.289-7.329-7.328-7.329zm-.002 16.493C4.114 18.823.002 14.712 0 9.66.002 4.604 4.114.49 9.166.49c5.053 0 9.165 4.112 9.167 9.167 0 5.054-4.113 9.166-9.169 9.166z",
    clipRule: "evenodd"
  })]
});

MagnifyingGlassIcon.defaultProps = {
  color: 'currentColor',
  title: undefined
};
var _default = MagnifyingGlassIcon;
exports.default = _default;